export default "__VITE_ASSET__CZ5W8hnx__"